import { GridError } from '@get/api-interfaces';
import { createActionGroup, props } from '@ngrx/store';

export const GridErrorActions = createActionGroup({
  source: 'Grid Error',
  events: {
    'Add One Grid Error': props<{
      gridError: GridError;
    }>(),
    'Delete One Grid Error Success': props<{ idGridError: number }>()
  }
});
